import React, { Fragment } from 'react';
import Spinner from 'view/components/spinner';

const RenderLoading = ({ isLoading, children, ...props }) => (
  <Fragment>{isLoading ? <Spinner hasContainer /> : children}</Fragment>
);

export default RenderLoading;
